import AlertModal from './AlertModal';
import { AlertModalProps, AlertModalValueProps } from './types';

export type { AlertModalProps, AlertModalValueProps };
export default AlertModal;
